export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarRight.vue?vue&type=template&id=45f3eff6"


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar-right/SidebarRight.vue?vue&type=template&id=45f3eff6
// module id = null
// module chunks = 